import { Box, Button } from "@mui/material";
import { colors } from "../../../../../../theme/muiColors";
import { useDispatch } from "react-redux";
import { setWorkTeamItemSelected } from "../../../../../../redux/features/workTeamItem";

export const SwapyBaseBox = ({ type, disabled = false, swapyName = "baseWidget", slotName, sxProp = {}, children, sxPropContainer = {} }) => {
  const dispatch = useDispatch();

  const containerStyles = {
    borderRadius: 2,
    display: "flex",
    flexDirection: "row",
    justifyContent: "center",
    alignItems: "center",
    width: "100%",
    minHeight: "65px",
    border: "1px solid var(--fx-surface-border, #E2E8F0)",
    ...sxPropContainer,
  };

  const itemStyles = {
    border: `3px solid ${disabled ? colors.grey[300] : colors.blue[400]}`,
    zIndex: 1,
    backgroundColor: disabled ? colors.grey[100] : colors.blue[100],
    color: disabled ? colors.grey[500] : "inherit",
    borderRadius: 2,
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    width: "100%",
    height: "65px",
    cursor: disabled ? "not-allowed" : "grab",
    position: "relative",
    textTransform: "none",
    transition: "border-color 180ms ease, background-color 180ms ease, color 180ms ease",
    ...sxProp,
  };

  return (
    <Box data-swapy-slot={slotName || swapyName} sx={containerStyles}>
      <Button
        disabled={disabled}
        data-swapy-item={swapyName}
        data-disabled={disabled ? "true" : "false"}
        sx={itemStyles}
        onPointerEnter={() => dispatch(setWorkTeamItemSelected({ type }))}
      >
        {children}
      </Button>
    </Box>
  );
};
